export const OPEN_REGISTER_SCHEDULE_MODAL = 'OPEN_REGISTER_SCHEDULE_MODAL';
export const CLOSE_REGISTER_SCHEDULE_MODAL = 'CLOSE_REGISTER_SCHEDULE_MODAL';
export const OPEN_UPDATE_SCHEDULE_MODAL = 'OPEN_UPDATE_SCHEDULE_MODAL';
export const CLOSE_UPDATE_SCHEDULE_MODAL = 'CLOSE_UPDATE_SCHEDULE_MODAL';